import React from 'react';
import columns from '../../../../react-table/helpers/columns';
import { roundDecimal } from '../../../common/redux/selectors/util';
import { sumTotal, totalRowRatio } from '../../../../react-table/helpers/rowTotals';

function determineClassName(value) {
  let className = '';
  if (value >= 97.0 && value <= 100.0) {
    className = 'bg-through-dark-green';
  }
  if (value >= 95.0 && value <= 96.9) {
    className = 'bg-through-dark-yellow';
  }

  if (value <= 94.9) {
    className = 'bg-through-dark-red';
  }
  return className;
}

export function getGetPropsForWeek(week) {
  return ((state, rowInfo) => {
    let className = '';
    if (rowInfo) {
      const percentage = (rowInfo.row[`pct${week.number}`]);
      className = determineClassName(percentage);
    }
    return {
      className,
    };
  });
}

export function weekColumns(weeks, data) {
  const { NumberColumn, PercentageColumn } = columns(data);
  return weeks.map((week, index) => ({
    Header: () => (
      <div>
        <p>Week {week.number}</p>
        <p>{week.startDate} to {week.endDate}</p>
      </div>
    ),
    metadataForDownload: {
      week: `Week ${week.number}`,
      date: `${week.startDate} to ${week.endDate}`,
    },
    columns: [
      new NumberColumn(
        'PREDES',
        row => row.weeks[index].predes,
      )
        .withId(`predes${week.number}`)
        .withTotalHeader(sumTotal),
      new NumberColumn(
        'RESDES',
        row => row.weeks[index].resdes,
      )
        .withId(`resdes${week.number}`)
        .withTotalHeader(sumTotal),
      new PercentageColumn(
        '%',
        row => roundDecimal(row.weeks[index].pct),
      )
        .withId(`pct${week.number}`)
        .withGetProps(getGetPropsForWeek(week))
        .withTotalHeader(totalRowRatio([`resdes${week.number}`, `predes${week.number}`])),
    ],
  }));
}
